import { createElement, type ReactNode } from 'react'

import { EditorPermissionsDescription } from './EditorPermissionsDescription'

/** Fallback display name when a member's name is unavailable. */
export const kUnavailableMemberName = 'Unavailable user'
/** Fallback email when a member's email is unavailable. */
export const kUnavailableMemberEmail = 'Email unavailable'

/** Contributor permissions shown in the invitation menu and Roles & Permissions popover. */
export const kContributorRoleDescription = 'Manage files and view any record, chat, draft, or table.'

/** Role label and description pairs shown in the Roles & Permissions popover. */
export function getMatterRoleDescriptions(editorEnabled = false, hasEditorAssignments = false): { label: string; description: ReactNode }[] {
  return [
    {
      label: 'Contributor',
      description: kContributorRoleDescription,
    },
    ...(editorEnabled || hasEditorAssignments
      ? [
          {
            label: 'Editor',
            description: editorEnabled ? createElement(EditorPermissionsDescription) : 'Contributor access. Matter Record editing is currently unavailable',
          },
        ]
      : []),
  ]
}
